/* ===== AROMAZUR : menu mobile (panneau manquant dans le thème) ===== */
(function(){
  function build(){
    if(document.getElementById('mobileMenu')) return;
    var burger=document.querySelector('.burger');
    if(!burger) return;
    /* styles */
    var st=document.createElement('style');
    st.textContent='.topbar,.topbar *{pointer-events:none !important}'+
      '#mmOv{position:fixed;inset:0;background:rgba(0,0,0,.55);opacity:0;pointer-events:none;transition:.3s;z-index:9998}'+
      '#mmOv.open{opacity:1;pointer-events:auto}'+
      '#mobileMenu{position:fixed;top:0;right:-300px;width:280px;height:100%;background:#111111;z-index:9999;transition:right .3s;display:flex;flex-direction:column;padding:26px 22px;box-sizing:border-box;overflow-y:auto}'+
      '#mobileMenu.open{right:0}'+
      '#mobileMenu .mm-logo{font-family:Georgia,serif;font-size:19px;letter-spacing:5px;color:#fff8f0;margin-bottom:6px}'+
      '#mobileMenu .mm-logo span{color:#D4A63C}'+
      '#mobileMenu .mm-close{position:absolute;top:14px;right:14px;background:none;border:none;color:#fff8f0;font-size:26px;cursor:pointer;line-height:1}'+
      '#mobileMenu a{display:block;padding:13px 2px;color:#fff8f0;text-decoration:none;font-family:Georgia,serif;font-size:15px;letter-spacing:1px;border-bottom:1px solid rgba(255,248,240,.08)}'+
      '#mobileMenu a:active{color:#D4A63C}'+
      '#mobileMenu .mm-foot{margin-top:auto;padding-top:18px;font-size:11px;color:#8a8272;font-family:Georgia,serif;letter-spacing:1px}'+
      '#mobileMenu .mm-search{margin:10px 0 14px}'+
      '#mobileMenu .mm-lab{position:absolute;left:-9999px}'+
      '#mobileMenu .mm-search input{width:100%;box-sizing:border-box;background:#1c1c1c;border:1px solid rgba(255,248,240,.18);color:#fff8f0;padding:11px 12px;font-family:inherit;font-size:14px;min-height:44px}'+
      '#mobileMenu .mm-search input::placeholder{color:#8a8272}'+
      '#mobileMenu .mm-search input:focus{outline:2px solid #D4A63C;outline-offset:1px}'+
      '#mobileMenu .mm-sec{margin-top:16px;padding-top:14px;border-top:1px solid rgba(255,248,240,.14);font-size:10px;letter-spacing:2px;text-transform:uppercase;color:#8a8272;font-family:Georgia,serif}'+
      '#mobileMenu a{min-height:44px;display:flex;align-items:center}';
    document.head.appendChild(st);
    /* overlay */
    var ov=document.createElement('div'); ov.id='mmOv';
    ov.addEventListener('click',function(){ if(window.closeMobileMenu)closeMobileMenu(); });
    document.body.appendChild(ov);
    /* panneau */
    var mm=document.createElement('nav'); mm.id='mobileMenu';
    var links='';
    var nav=document.querySelectorAll('header nav a[data-az-scroll], header ul a[data-az-scroll], .nav-links a[data-az-scroll], header nav a[href^="#"], header ul a[href^="#"], .nav-links a');
    if(nav.length){
      nav.forEach(function(a){ links+='<a href="'+a.getAttribute('href')+'"'+(a.getAttribute('data-az-scroll')?' data-az-scroll="'+a.getAttribute('data-az-scroll')+'"':'')+'>'+a.textContent.trim()+'</a>'; });
    } else {
      links='<a href="/collections/diffuseurs" data-az-scroll="#diffuseurs">Diffuseurs</a><a href="/collections/huiles-parfumees" data-az-scroll="#huiles">Huiles Parfumées</a><a href="/#quiz">Quiz</a><a href="/blogs/blog" data-az-scroll="#blog">Journal</a><a href="/pages/avantages-de-labonnement" data-az-scroll="#abonnement">Abonnement</a><a href="/collections/packs" data-az-scroll="#packs">Packs</a><a href="/pages/marketing-olfactif" data-az-scroll="#b2b">Professionnels</a>';
    }
    /* La recherche etait masquee sous 860 px et absente du panneau : sur mobile,
       aucun moyen de chercher un parfum par son nom parmi 32 signatures. */
    var recherche='<form class="mm-search" action="/search" method="get" role="search">'+
      '<label class="mm-lab" for="mmQ">Rechercher</label>'+
      '<input id="mmQ" type="search" name="q" placeholder="Un parfum, un diffuseur…" autocomplete="off">'+
      '</form>';
    var aide='<div class="mm-sec">Aide</div>'+
      '<a href="/pages/suivi-de-commande">Suivi de commande</a>'+
      '<a href="/pages/faq">Foire aux questions</a>'+
      '<a href="/pages/contact">Nous contacter</a>';
    mm.innerHTML='<div class="mm-logo">AROMA<span>ZUR</span></div>'+
      '<button class="mm-close" aria-label="Fermer le menu">&times;</button>'+
      recherche+links+aide+
      '<div class="mm-foot">AROMAZUR · Grasse, France</div>';
    document.body.appendChild(mm);
    mm.querySelector('.mm-close').addEventListener('click',function(){ if(window.closeMobileMenu)closeMobileMenu(); });
    mm.querySelectorAll('a').forEach(function(a){ a.addEventListener('click',function(){ if(window.closeMobileMenu)closeMobileMenu(); }); });
    /* openMobileMenu / closeMobileMenu n'etaient definis que dans index.liquid :
       sur toute autre page le burger appelait une fonction inexistante. */
    if(typeof window.openMobileMenu!=='function'){
      window.openMobileMenu=function(){ mm.classList.add('open'); ov.classList.add('open'); document.body.style.overflow='hidden'; };
    }
    if(typeof window.closeMobileMenu!=='function'){
      window.closeMobileMenu=function(){ mm.classList.remove('open'); ov.classList.remove('open'); document.body.style.overflow=''; };
    }
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&mm.classList.contains('open')&&window.closeMobileMenu)closeMobileMenu(); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',build); else build();
})();
